import React from 'react'

import { Field } from 'common/fields/entities/field'
import MCTextViewer from 'components/MCTextEditor/viewer/MCTextViewer'

import { AllowedValues } from '../types'

export interface MCTextViewerLegacyProps {
  className?: string
  getFields: () => Field[]
  preview?: boolean
  value?: AllowedValues
  builderId?: string
}

const MCTextViewerWithLegacyAPI = ({
  getFields,
  preview = true,
  ...props
}: MCTextViewerLegacyProps) => {
  return <MCTextViewer {...props} variablesConfig={{ getFields, preview }} readonly />
}

export default MCTextViewerWithLegacyAPI
